import BibliQuienGamePage from '../pages/BibliQuienGamePage';
import BibliQuienProductPage from '../pages/BibliQuienProductPage';

export const bibliquienRoutes = [
  {
    path: 'bibliquien',
    element: <BibliQuienGamePage />,
  },
  {
    path: 'bibliquien/producto',
    element: <BibliQuienProductPage />,
  },
];
